var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special_detail_container"},[(
      !!_vm.contentId &&
      !!_vm.detail &&
      _vm.detail.indexMode == 1 &&
      _vm.detail.classfyStyleMode == 1
    )?_c('template001',{attrs:{"detail":_vm.detail,"contentId":_vm.contentId,"deviceId":_vm.deviceId}}):(
      !!_vm.contentId &&
      !!_vm.detail &&
      _vm.detail.indexMode == 1 &&
      _vm.detail.classfyStyleMode == 2
    )?_c('template002',{attrs:{"detail":_vm.detail,"contentId":_vm.contentId,"deviceId":_vm.deviceId}}):(!!_vm.contentId && !!_vm.detail && _vm.detail.indexMode == 2)?_c('template003',{attrs:{"detail":_vm.detail,"contentId":_vm.contentId,"deviceId":_vm.deviceId,"infoKey":_vm.infoKey}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }